import React from 'react'
import { VertTypography } from '@vertem-core/vertice-ds';

import { getOrderStatus } from 'Utils/orders';

export const OrderStatus = ({ status }) => {
  const statusColor = getOrderStatus(status).color;
  const statusLabel = getOrderStatus(status).label;

  return (
    <VertTypography.Paragraph className={`order-status ${statusColor}`}>
      {statusLabel}
    </VertTypography.Paragraph>
  );
};
